/* Component for a not sticky timecard — timeline events with medium/low priority or short content uses this */ 

import React, { useState, useEffect } from 'react';
import { cardcontainer, 
    datecontainer, 
    cardcontent,
    cardtitle,
    cardtext,
    sideGraphicRight,
    sideGraphicLeft,
    centerGraphic, 
    polileg,
    viol,
    action,
    grassroots,
    icon} from './notsticky-timecard.module.css';
import politicalIcon from "../../pages/immigration-agriculture/icons/political-icon.svg";
import violenceIcon from "../../pages/immigration-agriculture/icons/violence-icon.svg";
import grassrootsIcon from "../../pages/immigration-agriculture/icons/grassroots-icon.svg"
import actionIcon from "../../pages/immigration-agriculture/icons/action-icon.svg"

const NotstickyCard = ({data, id, children, centerGraphics, sideGraphics, graphicsAlign, category="none"}) => {

    const cardData = data.filter( d => d.id == id )[0];
    const listCenterGraphics = centerGraphics.length != 0 ? centerGraphics.map((graphic) => {
        const basePath = "../../oregon-timeline-graphics/";
        const centerGraphicPath = basePath.concat(graphic);

        return (
            <img className={centerGraphic} src={centerGraphicPath}></img>
        )
    }) : null;

   const listSideGraphics = sideGraphics.length != 0 ? sideGraphics.map((sideGraphic) => {
        const basePath = "../../oregon-timeline-graphics/";
        const sideGraphicPath = basePath.concat(sideGraphic);

        return (
            <img className={graphicsAlign == "left" ? sideGraphicLeft : sideGraphicRight} src={sideGraphicPath}></img>
        )
    }) : null;



    return (
        <section className = {`${cardcontainer} ${category == "politics-legislation" ? polileg : category == "violence" ? viol : category == "grassroots" ? grassroots : category == "action" ? action : ""}`}>
            <article className = {datecontainer}>
                <p>{ cardData.year }</p>
                <img className = {icon} src = {category == "politics-legislation" ? politicalIcon : category == "violence" ? violenceIcon : category == "grassroots" ? grassrootsIcon : category == "action" ? actionIcon : null}></img>
            </article>
            <article className = {cardcontent}>
                <h4 className = {cardtitle}>
                    {cardData.title}
                </h4>
                <h5 className = {cardtext}>
                    {cardData.text}
                </h5>
                {listCenterGraphics}
                {listSideGraphics}
            </article>
        </section>
    )
}

/*const NotstickyCard = ( {date, title, children}) => {

    return (
        <section className = {container}>
        <article className = {datecontainer}>
            <p>{ date }</p>
        </article>
        <article className = {content}>
            <h4 className = {cardtitle}>
                {title}
            </h4>
            {children}
        </article>
    </section>
    )
}*/

export default NotstickyCard